import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { authApi } from '@/api/authApi'
import apiClient from '@/api/client'
import type { User } from '@/types'
import { useAuthStore } from '@/store/authStore'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'

export const RegisterPage: React.FC = () => {
  const navigate = useNavigate()
  const { setUser } = useAuthStore()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (password.length < 6) {
      setError('Пароль должен быть не менее 6 символов')
      return
    }

    setLoading(true)

    try {
      const tokens = await authApi.register(email, password, name)
      localStorage.setItem('access_token', tokens.access_token)
      localStorage.setItem('refresh_token', tokens.refresh_token)

      const { data: user } = await apiClient.get<User>('/users/me')
      useAuthStore.getState().setCurrentAssistant(null)
      setUser(user)

      navigate('/')
    } catch (err: any) {
      if (err?.code === 'EMAIL_EXISTS') {
        setError('Этот email уже зарегистрирован')
      } else {
        setError(err?.error || err?.message || 'Ошибка регистрации')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: 'var(--bg-secondary)' }}
    >
      <div
        className="w-full max-w-[400px] rounded-2xl p-8"
        style={{
          backgroundColor: 'var(--bg-primary)',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        }}
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/logo.png" alt="ProCoach" className="w-10 h-10 rounded-xl" />
          <span className="text-[22px] font-bold" style={{ color: 'var(--text-primary)' }}>
            ProCoach
          </span>
        </div>

        <h2 className="text-[18px] font-semibold text-center mb-6" style={{ color: 'var(--text-primary)' }}>
          Создать аккаунт
        </h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input
            label="Ваше имя"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Иван Петров"
            required
            autoFocus
          />
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="coach@example.com"
            required
          />
          <Input
            label="Пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Минимум 6 символов"
            required
          />

          {error && (
            <div
              className="text-[13px] px-3 py-2 rounded-lg"
              style={{ backgroundColor: 'var(--danger-light)', color: 'var(--danger)' }}
            >
              {error}
            </div>
          )}

          <Button type="submit" loading={loading} className="w-full mt-2">
            Зарегистрироваться
          </Button>
        </form>

        <p className="text-center text-[14px] mt-6" style={{ color: 'var(--text-secondary)' }}>
          Уже есть аккаунт?{' '}
          <Link
            to="/login"
            className="font-medium hover:underline"
            style={{ color: 'var(--accent)' }}
          >
            Войти
          </Link>
        </p>
      </div>
    </div>
  )
}
